export default "https://cdn-static.gokick.com/assets/510b01776e4307c2b342e37a2ed4ce502ef69aad/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";